if (!customElements.get('site-accordion-collapse')) {
  customElements.define(
    'site-accordion-collapse',
    class SiteAccordeonCollapse extends HTMLElement {
      constructor() {
        super();
        const readMoreElement = this.querySelector('[data-accordion-collapse-read-more]');
        const readMoreWrap = this.querySelector('[data-accordion-collapse]');

        if (readMoreElement && readMoreWrap) {
          this.showReadMoreToggle(readMoreWrap, readMoreElement);

          readMoreElement.addEventListener('click', (event) => {
            this.toggleShowMore(event.target);
          });
        }
      }

      /**
       * show the read more / read less button when element has overflow
       * @param {HTMLElement} readMoreWrap
       * @param {HTMLElement} readMore
       */
      showReadMoreToggle(readMoreWrap, readMoreLink) {
        if (readMoreWrap.offsetHeight < readMoreWrap.scrollHeight) {
          // show read more / read less button
          readMoreLink.classList.add('show');
          readMoreWrap.classList.remove('hide-ellipsis');
        } else {
          // element doesn't overflow
          readMoreLink.classList.remove('show');
          readMoreWrap.classList.add('hide-ellipsis');
        }
      }

      /**
       * Toggle show more / show less
       * @param {HTMLElement} targetElement
       */
      toggleShowMore(targetElement) {
        if (this.classList.contains('accordion__content__collapsed')) {
          this.classList.remove('accordion__content__collapsed');
          targetElement.innerHTML = targetElement.dataset.accordionReadLess;
        } else {
          this.classList.add('accordion__content__collapsed');
          targetElement.innerHTML = targetElement.dataset.accordionReadMore;
        }
      }
    }
  );
}
